const wordsToRemove = [
    /\beng\b/i,
    /\bdr\b/i,
    /\bphd\b/i,
    /\bms\b/i,
    /\bmr\b/i,
    /\bph\b/i,
    /\bp\b/i
];

export default wordsToRemove;
